import { useMemo } from 'react'
import brandConfig from '../brand-config.json'

interface TipsterInfo {
  displayName: string
  description: string
  imageUrl: string
  instagramUrl: string
  telegramUrl: string
  xUrl: string
  linkedinUrl?: string
  websiteUrl: string
  channelId: string
}

interface BrandConfig {
  brandName: string
  appTitle: string
  logo?: string
  showBrandImageInHeader?: boolean
  showPoweredBy?: boolean
  statsColors?: {
    won: string
    lost: string
    void: string
    pending: string
  }
  tipsterInfo?: TipsterInfo
  competitionsPlaceholderImageUrl?: string
}

export const useBrandConfig = (): BrandConfig => {
  return useMemo(() => brandConfig as BrandConfig, [])
}
